const actions = {
  async listCommissionRequest(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_commission_request.list",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationCommissionRequestList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationCommissionRequestList", responseData);
      }

      context.commit("mutationCommissionRequestMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationCommissionRequestList", []);
      context.commit("mutationCommissionRequestMeta", {});

      throw error;
    }
  },
};

export default actions;
